import { Link } from 'react-router-dom';

export default function SiteIntro() {
  return (
    <section className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-12 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12 items-start">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-information-line"></i>
              网站简介
            </span>
            <h2 className="mt-4 text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              关于吃瓜网
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl">
              吃瓜网是一家聚焦最新热点新闻、娱乐八卦与社会事件资讯的平台，目标用户是喜欢及时获取明星动态、
              网络热议话题和社会热点的年轻及中年互联网用户。我们希望用清晰的结构与舒适的阅读体验，
              让每一条热点都能被快速看懂。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/category/entertainment"
                className="inline-flex items-center gap-1.5 h-10 px-4 rounded-md bg-primary-500 text-primary-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                逛娱乐频道
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-1.5 h-10 px-4 rounded-md border border-background-300 bg-background-50 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                了解我们
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 md:gap-4">
            {[
              { num: '16', label: '演示资讯', icon: 'ri-article-line' },
              { num: '4', label: '新闻分类', icon: 'ri-layout-grid-line' },
              { num: '24h', label: '热点追踪', icon: 'ri-time-line' },
              { num: '100%', label: '免费阅读', icon: 'ri-book-open-line' },
            ].map((s) => (
              <div key={s.label} className="rounded-lg border border-background-200 bg-background-50 p-4">
                <span className="w-9 h-9 rounded-md bg-accent-100 text-accent-600 flex items-center justify-center">
                  <i className={`${s.icon} text-lg`}></i>
                </span>
                <p className="mt-3 text-xl font-bold font-heading text-foreground-950">{s.num}</p>
                <p className="mt-0.5 text-xs text-foreground-500">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}